import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Image from 'next/image';
import Link from 'next/link';
import { setSuffix } from '../../../utils/helpers';

const AgencyCard = ({ id, path, logoUrl, name, itemsCount, description }) => {
  const { i18n, t } = useTranslation();

  return (
    <Link className="agencies-i" key={id} href={path}>
      <div className="agencies-i--logo">
        <Image src={logoUrl} fill alt="" />
      </div>
      <div className="agencies-i--wrapper">
        <div className="agencies-i--title">{name}</div>
        <div className="agencies-i--offers-count">
          {t(setSuffix(i18n, itemsCount, 'sections.agencies.agencies_count'), {
            n: itemsCount
          })}
        </div>
        <div className="agencies-i--description">{description}</div>
      </div>
    </Link>
  );
};

AgencyCard.propTypes = {
  id: PropTypes.string,
  path: PropTypes.string,
  name: PropTypes.string,
  logoUrl: PropTypes.string,
  description: PropTypes.string,
  itemsCount: PropTypes.number
};

export default AgencyCard;
